import { render, staticRenderFns } from "./BioEditLink.vue?vue&type=template&id=0ab7e0f5&scoped=true&"
import script from "./BioEditLink.vue?vue&type=script&lang=js&"
export * from "./BioEditLink.vue?vue&type=script&lang=js&"
import style0 from "./BioEditLink.vue?vue&type=style&index=0&id=0ab7e0f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab7e0f5",
  null
  
)

export default component.exports